
<v-app id="app" :class="{hasBasketDock: showBasketDock}" :style="{'--basketDockHeight': `${shopLayout.dockHeight}px`}">
  <ToolBar/>
  <v-main id="appContent" ref="content">
    <v-container fluid class="shopPageContainer">
      <router-view :key="$route.fullPath"/>
    </v-container>
  </v-main>
  <Footer id="shopFooter" ref="footer"/>
  <BasketDock v-if="showBasketDock" :footer-element="footerElement" :content-element="contentElement"/>
</v-app>
